import { render, staticRenderFns } from "./AddonsModal.vue?vue&type=template&id=106693a6&scoped=true"
import script from "./AddonsModal.vue?vue&type=script&lang=js"
export * from "./AddonsModal.vue?vue&type=script&lang=js"
import style0 from "./AddonsModal.vue?vue&type=style&index=0&id=106693a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106693a6",
  null
  
)

export default component.exports